import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { PatternDto } from '../types';

export const usePatterns = (projectUuid?: string) => {
  return useQuery<PatternDto[]>({
    queryKey: ['patterns', projectUuid],
    queryFn: () => apiClient.get(`/v1/projects/${projectUuid}/patterns`),
    enabled: !!projectUuid,
  });
};
